import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const HEADER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas digitales.';
const navLinks = [{
  href: '#sistemas',
  label: 'Sistemas'
}, {
  href: '#como-funciona',
  label: 'Cómo funciona'
}, {
  href: '#precios',
  label: 'Precios'
}, {
  href: '#voice',
  label: 'VOICE'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <>
      <header className={`fixed top-0 w-full z-[100] transition-all duration-300 ${isScrolled ? 'bg-[#F7F4ED]/90 backdrop-blur-[12px] border-b border-carbon/10' : 'bg-transparent'}`} data-id="element-37" data-mp="2wlvxgyfy65o0">
        <div className="max-w-[1200px] mx-auto px-6 md:px-20 h-[64px] md:h-[72px] flex items-center justify-between" data-id="element-38" data-mp="2mnq2l0sk5zsn">
          <Link to="/" className="flex items-center" aria-label="Origen Studio — inicio" data-id="element-39" data-mp="2hp516y1kla2m">
            <Logo variant="light" data-id="element-40" data-mp="3fasv9cajzgaz" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-10" data-id="element-41" data-mp="3adal5iksuv1e">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-42" data-mp="35khhky12hsqw">
                {link.label}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-43" data-mp="3t9slgodps399">
            <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[13px] px-5 py-2.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-44" data-mp="1rd1j2sm1afhs">
              Hablar con ORIGEN
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-carbon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Abrir menú" aria-expanded={isMobileMenuOpen} data-id="element-45" data-mp="1cpq6cne48pg3">
            {isMobileMenuOpen ? <X size={24} data-id="element-46" data-mp="13ptpv91vqww4" /> : <Menu size={24} data-id="element-47" data-mp="2t36msd7nxin7" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[90] bg-arena pt-[72px] px-6 pb-10 flex flex-col md:hidden" data-id="element-48" data-mp="2y0ozmeoswi0h">
          <nav className="flex flex-col gap-8 mt-8" data-id="element-49" data-mp="mfg32kjcjlec">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-50" data-mp="hgweecddbvia">
                {link.label}
              </a>)}
          </nav>
          <div className="mt-auto" data-id="element-51" data-mp="1544m10y9rgnh">
            <a href={getWhatsAppLink(HEADER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-verde text-arena font-display font-semibold text-[15px] px-7 py-4 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" onClick={() => setIsMobileMenuOpen(false)} data-id="element-52" data-mp="1578u49euuwjf">
              Hablar con ORIGEN
            </a>
          </div>
        </div>}
    </>;
}